function t(i) {
  if (i)
    throw i;
}
export {
  t as bail
};
//# sourceMappingURL=index.js.map
